/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum AdDataKey {
  /**
   * Ad identifier. Example: 23453452134
   */
  AD_ID = 'ad_id',
  /**
   * Ad title. Example: "Buy the new product now!"
   */
  AD_TITLE = 'ad_title',
  /**
   * Type of ad. Example: preroll, postroll, midroll
   */
  AD_TYPE = 'ad_type',
  /**
   * Ad duration in milliseconds. Example: 15000
   */
  AD_DURATION_MS = 'ad_duration_ms',
  /**
   * Ad skip offset value  in milliseconds. Example: 5000
   */
  AD_SKIP_OFFSET_MS = 'ad_skip_offset_ms',
  /**
   *  Media URL of the ad. Example: https://example.com/ad.mp4
   */
  AD_CLICK_URL = 'ad_click_url',
  /**
   * Ad duration in seconds. Example: 15
   */
  AD_DURATION = 'ad_duration',
  /**
   * Ad skip offset value  in seconds. Example: 5
   */
  AD_SKIP_OFFSET = 'ad_skip_offset',
  /**
   * Ad creative identifier. Example: 12345
   */
  AD_CREATIVE_ID = 'ad_creative_id',
}
